import { render } from "./FilePreviewer.vue?vue&type=template&id=46c0a1b6&scoped=true"
import script from "./FilePreviewer.vue?vue&type=script&lang=js"
export * from "./FilePreviewer.vue?vue&type=script&lang=js"

import "./FilePreviewer.vue?vue&type=style&index=0&id=46c0a1b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c0a1b6"]])

export default __exports__